var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18501 7.92506C2.27322 7.72521 1.51445 7.26308 0.908665 6.53864C0.302885 5.8142 0 4.97112 0 4.00937C0 3.45979 0.106166 2.94145 0.318501 2.45433C0.530836 1.96721 0.814986 1.54255 1.17096 1.18033C1.52693 0.818109 1.94848 0.530836 2.4356 0.318501C2.92272 0.118656 3.44106 0.01249 3.99063 0C4.54021 0 5.05855 0.106166 5.54567 0.318501C6.03279 0.530836 6.45745 0.818109 6.81967 1.18033C7.18189 1.54255 7.46916 1.96721 7.6815 2.45433C7.89383 2.94145 8 3.45979 8 4.00937C8 4.97112 7.69711 5.8142 7.09133 6.53864C6.48556 7.26308 5.72678 7.72521 4.81499 7.92506H4.79625V15.1944C4.79625 15.4192 4.71819 15.6097 4.56206 15.7658C4.40593 15.9219 4.21546 16 3.99063 16C3.76581 16 3.57533 15.9219 3.4192 15.7658C3.26308 15.6097 3.18501 15.4192 3.18501 15.1944V7.92506Z",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocation);
export default __webpack_public_path__ + "static/media/ico-location.e20f614a.svg";
export { ForwardRef as ReactComponent };